/**
 * RADIO-BTN
 */

import { useState } from "react"
import SaveIcon from "./save-icon"

interface OwnProps {
  active?: boolean //Is radio button active
  id?: string //Id of the radio button
  onClick: Function | null //Function to trigger onclick
  status?: string //Show save status
  text?: string //Text to display
  disabled?: boolean //enable / disable radio button
  className?: string //custom className
}

function RadioBtn(props: OwnProps) {
  //Show status after editing
  const [showStatus, setShowStatus] = useState(false)

  //Trigger click on radio button
  function click(event: any) {
    if (props.disabled) return
    event.stopPropagation()

    setShowStatus(true)

    if (props.onClick) {
      props.onClick({ id: props.id, value: !props.active })
    }

    setTimeout(() => {
      setShowStatus(false)
    }, 2000)
  }

  function getClassName() {
    let className = "radio-container flex"

    if (!props.onClick || props.disabled) {
      className += " radio-inactive"
    }

    if (props.className) {
      className += " " + props.className
    }

    return className
  }

  return (
    <div className={getClassName()}>
      <div onClick={click} className={props.active ? "radio radio-active flex" : "radio"} />

      {props.text && <div className="radio-label">{props.text}</div>}

      {props.status && <SaveIcon status={showStatus ? props.status : null} />}
    </div>
  )
}

export default RadioBtn
